import { useParams, Link, Navigate } from "react-router-dom";
import { POSTS, COMPANY } from "../lib/content";
import { Reveal, MaskReveal } from "../components/Reveal";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

export default function JournalPost() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/journal" replace />;

  const index = POSTS.findIndex((p) => p.slug === slug);
  const next = POSTS[(index + 1) % POSTS.length];

  return (
    <article className="pt-32 md:pt-40 pb-24 bg-cream" data-testid="journal-post">
      <header className="container-edge">
        <Link to="/journal" className="overline text-ink/55 hover:text-ink inline-flex items-center gap-2" data-testid="back-to-journal">
          <ArrowLeft size={12} /> Back to Journal
        </Link>
        <div className="overline text-ink/55 mt-10">{post.category} · {post.date}</div>
        <MaskReveal delay={0.05}>
          <h1 className="font-display uppercase text-6xl md:text-[10vw] leading-[0.85] mt-4">
            {post.title}
          </h1>
        </MaskReveal>
        <div className="overline text-ink/55 mt-8">By {post.author} · {COMPANY.name}</div>
      </header>

      <div className="container-edge mt-12 md:mt-16">
        <div className="overflow-hidden">
          <img src={post.img} alt={post.title} loading="eager" fetchPriority="high" decoding="async" className="w-full aspect-[16/9] md:aspect-[21/9] object-cover img-bw" />
        </div>
      </div>

      <section className="container-edge mt-16 md:mt-24 grid grid-cols-12 gap-x-8 gap-y-10">
        <aside className="col-span-12 md:col-span-3 md:sticky md:top-32 md:self-start">
          <div className="overline text-ink/55">The Excerpt</div>
          <p className="font-serif italic text-xl md:text-2xl leading-snug mt-4 text-ink/80">
            {post.excerpt}
          </p>
        </aside>

        <div className="col-span-12 md:col-span-8 md:col-start-5 prose-editorial">
          {(post.body || []).map((para, i) => (
            <Reveal key={i} delay={i * 0.03}>
              <p className="font-serif text-xl md:text-2xl leading-[1.55] text-ink/85 mb-7">
                {para}
              </p>
            </Reveal>
          ))}

          <div className="border-t border-ink/15 mt-14 pt-8 flex items-baseline justify-between flex-wrap gap-4">
            <span className="overline text-ink/55">— {post.author}, {post.date}</span>
            <Link
              to={`/journal/${next.slug}`}
              className="btn-ghost"
              data-testid="next-post"
            >
              Next: {next.title} <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </section>
    </article>
  );
}
